export const SET_USERS = 'SET_USERS'
export const SET_ROLES = 'SET_ROLES'
export const ADD_USER = 'ADD_USER'
export const DELETE_USER = 'DELETE_USER'



// WEBPACK FOOTER //
// ./src/store/modules/user/types.js